var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37295 12.75L12.5422 17.9192C12.6909 18.0679 12.7643 18.2419 12.7625 18.4412C12.7605 18.6406 12.682 18.8178 12.527 18.973C12.3718 19.1178 12.1961 19.1928 12 19.198C11.8038 19.2032 11.6281 19.1282 11.473 18.973L5.1327 12.6327C5.03904 12.5391 4.97304 12.4403 4.9347 12.3365C4.8962 12.2327 4.87695 12.1205 4.87695 12C4.87695 11.8795 4.8962 11.7673 4.9347 11.6635C4.97304 11.5597 5.03904 11.4609 5.1327 11.3672L11.473 5.02699C11.6115 4.88849 11.783 4.81766 11.9875 4.81449C12.192 4.81133 12.3718 4.88216 12.527 5.02699C12.682 5.18216 12.7595 5.36033 12.7595 5.56149C12.7595 5.76283 12.682 5.94108 12.527 6.09624L7.37295 11.25H18.75C18.9628 11.25 19.141 11.3218 19.2845 11.4655C19.4281 11.609 19.5 11.7872 19.5 12C19.5 12.2128 19.4281 12.391 19.2845 12.5345C19.141 12.6782 18.9628 12.75 18.75 12.75H7.37295Z",
    fill: "#ddd9d9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow_back.482bc7f11537fde054c41db9e92c5252.svg";
export { ForwardRef as ReactComponent };